import store from "src/storeWire";
import {system_notification} from "src/store/slice/system";

export class Popup {
    static dispatchIt(popup_name, data) {
        store.dispatch(system_notification({
            name: popup_name,
            data: data,
        }));
    }

    static systemAlert(content, type = 'success', errorModule = '', do_not_auto_focus = false) {
        let dataExport = {
            name: 'SystemAlerts',
            data: {
                content,
                type,
                errorModule,
                do_not_auto_focus
            },
        };
        store.dispatch(system_notification(dataExport));
    }

    static clearAllAlert() {
        let dataExport = {
            name: 'SystemAlerts',
            data: {
                content: '',
                type: 'clear'
            },
        };
        store.dispatch(system_notification(dataExport));
    }
}